import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { Suspense, useContext } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import "./index.css";
import App from "./App";
import "./services/i18n";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@mui/material";
import { theme } from "@sequentech/ui-essentials";
import AuthContextProvider from "./providers/AuthContextProvider";
import { SettingsContext, SettingsWrapper } from "./providers/SettingsContextProvider";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorPage } from "./routes/ErrorPage";
import { VotingPortalError, VotingPortalErrorType } from "./services/VotingPortalError";
import { Loader } from "@sequentech/ui-essentials";
import TenantEvent from "./routes/TenantEvent";
import { electionRoutes } from "./routes/electionRoutes";
import PreviewPublicationEvent from "./routes/PreviewPublicationEvent";
import ElectionSelectionScreen from "./routes/ElectionSelectionScreen";
import LoginScreen from "./routes/LoginScreen";
import RegisterScreen from "./routes/RegisterScreen";
import SupportMaterialsScreen from "./routes/SupportMaterialsScreen";
import { WasmWrapper } from "./providers/WasmWrapper";
var root = ReactDOM.createRoot(document.getElementById("root"));
var KeycloakProvider = function (_a) {
    var disable = _a.disable, children = _a.children;
    return disable ? (_jsx(_Fragment, { children: children })) : (_jsx(AuthContextProvider, { children: _jsx(_Fragment, { children: children }) }));
};
export var KeycloakProviderContainer = function (_a) {
    var children = _a.children;
    var _b = useContext(SettingsContext), globalSettings = _b.globalSettings, setDisableAuth = _b.setDisableAuth;
    return _jsx(KeycloakProvider, { disable: globalSettings.DISABLE_AUTH, children: children });
};
export var ThrowCertAuthError = function () {
    throw new VotingPortalError(VotingPortalErrorType.CERT_AUTH_FAILED);
};
var router = createBrowserRouter([
    {
        path: "/cert-auth-error",
        element: _jsx(ThrowCertAuthError, {}),
        errorElement: _jsx(ErrorPage, {}),
    },
    {
        path: "/",
        element: _jsx(App, {}),
        errorElement: _jsx(ErrorPage, {}),
        children: [
            {
                path: "/preview/:tenantId/:documentId/:areaId/:publicationId",
                element: _jsx(PreviewPublicationEvent, {}),
            },
            {
                path: "/tenant/:tenantId/event/:eventId",
                element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(TenantEvent, {}) })),
                children: [
                    {
                        path: "election-chooser",
                        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(ElectionSelectionScreen, {}) })),
                    },
                    {
                        path: "login",
                        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(LoginScreen, {}) })),
                    },
                    {
                        path: "enroll",
                        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(RegisterScreen, {}) })),
                    },
                    electionRoutes,
                    {
                        path: "materials",
                        element: (_jsx(Suspense, { fallback: _jsx(Loader, {}), children: _jsx(SupportMaterialsScreen, {}) })),
                    },
                ],
            },
        ],
    },
], {
    basename: "/",
});
root.render(_jsx(React.StrictMode, { children: _jsx(WasmWrapper, { children: _jsx(SettingsWrapper, { children: _jsx(KeycloakProviderContainer, { children: _jsx(Provider, { store: store, children: _jsx(ThemeProvider, { theme: theme, children: _jsx(RouterProvider, { router: router }) }) }) }) }) }) }));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
